import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { loadStripe } from '@stripe/stripe-js/pure';

@Component({
  name: 'bpc-bancontact-payment-modal',
  components: {},
})
export default class BancontactPaymentModal extends Vue {
  @Prop({ type: Boolean, default: false }) readonly showModal: boolean;
  @Prop({ type: String, default: 'global.pay_with_bancontact' }) readonly modalTitle: string;
  @Prop({ type: Number, default: 0 }) readonly payAmount: number;
  @Prop({ type: Number, default: null }) readonly invoiceId: number;
  @Prop({ type: [String, Object], default: null }) readonly bancontactPaymentData: string | object;
  @Prop({ type: String, default: null }) readonly returnUrl: string;
  @Prop({ type: String, default: null }) readonly contactFullname: string;

  protected stripe;
  key: number = 0;
  blockBtnPay: boolean = false;
  blockBtnCancel: boolean = false;
  loadingPayment: boolean = false;
  showAlert: boolean = false;
  alertVariant: string = 'null';
  alertMessage: string = '';
  paymentMethodType: string = 'stripe_bancontact';
  customPaymentName: string = null;

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get stripeActivated() {
    return this.$store.getters['centerSettings/stripeActivated'];
  }

  get createPaymentIntentUrl() {
    return `${this.$bpcApiRouteHelper.getEntityPath('payment')}/bancontact/create-payment-intent`;
  }

  set customerPaymentName(customerName: string) {
    this.customPaymentName = customerName;
  }

  get customerPaymentName() {
    return this.$store.getters['auth/userName']
      ? this.$store.getters['auth/userName']
      : this.customPaymentName;
  }

  get isLoggedIn(): boolean {
    return this.$authService.isLoggedIn();
  }

  async mounted() {
    if (!this.stripeActivated) {
      this.showAlertMessage('danger', 'global.bancontact_is_not_active');
    } else if (!this.isValidPayAmount()) {
      this.blockBtnPay = true;
      this.showAlertMessage('danger', 'global.stripe_enough_amount');
    } else {
      const publicKey = this.$store.getters['centerSettings/stripePublicKey'];
      this.stripe = await loadStripe(publicKey);
    }
  }

  onMakePayment($event) {
    this.disableButtons(true);
    this.loadingPayment = true;
    this.hideAlertMessage();
    this.$emit('on-make-payment', $event);
  }

  async makePayment() {
    if (this.customerPaymentName) {
      this.blockBtnCancel = true;

      const paymentData = {
        amount: this.payAmount,
        lang: this.lang,
        invoiceId: this.invoiceId,
      };

      try {
        const res = await this.$bpcApi
          .post(this.createPaymentIntentUrl, paymentData, {}, 'public')
          .toPromise();
        this.confirmPaymentIntent(res.data.clientSecret);
      } catch (error) {
        this.showAlertMessage('danger', error.message);
        this.disableButtons(false);
      }
    } else {
      this.disableButtons(false);
      this.showAlertMessage('danger', 'global.bancontact_name_required');
    }
  }

  confirmPaymentIntent(clientSecret) {
    // Redirects away from the client
    this.stripe
      .confirmBancontactPayment(clientSecret, {
        payment_method: {
          billing_details: {
            name: this.customerPaymentName,
          },
        },
        return_url: this.returnUrl,
      })
      .then(function(result) {
        if (result.error) {
          // Inform the customer that there was an error.
        }
      });
  }

  disableButtons(value) {
    this.blockBtnPay = value;
    this.blockBtnCancel = value;
  }

  showAlertMessage(variant, message) {
    this.alertVariant = variant;
    this.alertMessage = message;
    this.showAlert = true;
  }

  showButtonsWhenNoAvailability() {
    this.blockBtnCancel = false;
    this.blockBtnPay = true;
    this.loadingPayment = false;
  }

  hideAlertMessage() {
    this.alertVariant = 'null';
    this.alertMessage = '';
    this.showAlert = false;
  }

  close() {
    this.$emit('click-on-close');
    this.hideAlertMessage();
  }

  cancelPayment() {
    this.$emit('click-on-cancel');
    this.hideAlertMessage();
  }

  isValidPayAmount() {
    return !(isNaN(this.payAmount) || this.payAmount <= 0);
  }
}
